const formatDuration = (durationInMillis) => {
  const totalSeconds = Math.floor(durationInMillis / 1000);  // Convert to seconds
  const hours = Math.floor(totalSeconds / 3600);  // Get the full hours (3600 seconds = 1 hour)
  const minutes = Math.floor((totalSeconds % 3600) / 60);  // Get the remaining minutes
  const seconds = totalSeconds % 60;  // Get the remaining seconds

  // Return the formatted duration
  let duration = '';
  if (hours > 0) {
    duration += `${hours} hr `;
  }
  duration += `${minutes} min ${seconds} sec`;

  return duration;
};
export default formatDuration